var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('config-option',{attrs:{"apiname":"moneycode","idname":"moneyCodeId","labelname":"รหัสหมวดหมู่ค่าใช้จ่าย"}})}
var staticRenderFns = []

export { render, staticRenderFns }